module.exports = __webpack_public_path__ + "img/np_competitors_3317994_F0CD5E.c4a04836.svg";